module.exports = __webpack_public_path__ + "img/23.550ad1ad.png";